import type { Command } from '@/context/CommandContext';
import { t } from '@/i18n/translator';

export const RateAssetCommand = (
  assetId: string,
  oldRating: number,
  newRating: number,
  updateRatingMutation: (vars: { id: string; body: { rating: number } }) => Promise<any>,
): Command => {
  const apply = () => updateRatingMutation({ id: assetId, body: { rating: newRating } });
  const undo = (): void => {
    void updateRatingMutation({ id: assetId, body: { rating: oldRating } });
  };
  const redo = (): void => {
    void apply();
  };

  return {
    apply,
    undo,
    redo,
    message: t('commands.rateAsset', { rating: newRating }),
  };
};
